<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col xs="12">
          <div class="card p-3 m-lg-3 mb-2 mt-2">
            <div class="header-card">
              <p class="card-title">Testspace Info</p>
            </div>

            <div class="body-card">
              <div class="field-division">
                <span class="field-label">Test Title</span>
                <b-form-input
                  :disabled="true"
                  :value="testspace.test_title"
                  placeholder="Topic Reference"
                ></b-form-input>
              </div>

              <div class="field-division">
                <span class="field-label">Test Description</span>
                <b-form-textarea
                  rows="5"
                  :disabled="true"
                  id="institutioninfo"
                  v-model="testspace.test_description"
                  required
                >
                </b-form-textarea>
              </div>

              <div class="field-division">
                <span class="field-label">Test organization</span>
                <b-form-input
                  :disabled="true"
                  :value="testspace.test_organization"
                  placeholder=""
                ></b-form-input>
              </div>
            </div>

            <div class="footer-edit text-right mt-3">
              <b-button
                class="v-button p-lg-2"
                :to="{
                  name: 'edittestspaces',
                  hash: '#info',
                  params: { trackid: testspace.track_id }
                }"
                variant="success"
                >Edit <b-icon-pencil-square></b-icon-pencil-square
              ></b-button>
            </div>
          </div>

          <div class="card p-3 m-lg-3 mb-2">
            <div class="header-card">
              <p class="card-title">Testspace Details</p>
            </div>
            <div class="body-card">
              <div class="field-division">
                <span class="field-label">Test Category</span>
                <b-form-input
                  :disabled="true"
                  :value="testspace.test_category"
                  placeholder="Topic Reference"
                ></b-form-input>
              </div>

              <div class="field-division">
                <span class="field-label">Test Institution</span>
                <b-form-input
                  :disabled="true"
                  :value="testspace.test_institution"
                  placeholder="Topic Reference"
                ></b-form-input>
              </div>

              <div
                v-if="testspace.test_structure == 'Section'"
                class="field-division"
              >
                <span class="field-label">Test Course</span>
                <b-form-input
                  :disabled="true"
                  :value="testspace.test_course"
                  placeholder="Topic Reference"
                ></b-form-input>
              </div>

              <div
                class="field-division"
                v-if="testspace.test_structure == 'Subject'"
              >
                <span class="field-label">Test Subjects</span>
                <b-form-checkbox-group
                  id="selectsubject"
                  :disabled="true"
                  :options="JSON.parse(testspace.test_subjects)"
                  name="subjectspo"
                  stacked
                ></b-form-checkbox-group>
              </div>
            </div>

            <div class="footer-edit text-right mt-3">
              <b-button
                class="v-button p-lg-2"
                :to="{
                  name: 'edittestspaces',
                  hash: '#details',
                  params: { trackid: testspace.track_id }
                }"
                variant="success"
                >Edit <b-icon-pencil-square></b-icon-pencil-square
              ></b-button>
            </div>
          </div>

          <div class="card p-3 m-lg-3 mb-2">
            <div class="header-card">
              <p class="card-title">Testspace Config</p>
            </div>
            <div class="body-card">
              <div class="field-division">
                <span class="field-label">Test Take Frequency</span>
                <b-form-spinbutton
                  id="modeque"
                  :disabled="true"
                  :value="Number(testspace.take_frequency)"
                  min="0"
                  max="100"
                  step="1"
                ></b-form-spinbutton>
              </div>

              <div class="field-division">
                <span class="field-label">Test Wall</span>
                <b-form-radio
                  v-model="testspace.test_wall"
                  :disabled="true"
                  name="wall"
                  value="Yes"
                  >Yes</b-form-radio
                >
                <b-form-radio
                  v-model="testspace.test_wall"
                  :disabled="true"
                  name="wall"
                  value="No"
                  >No</b-form-radio
                >
              </div>

              <div class="field-division">
                <span class="field-label">Space Mode</span>
                <b-form-radio
                  v-model="testspace.space_mode"
                  :disabled="true"
                  name="space_mode"
                  value="full"
                  >Full</b-form-radio
                >
                <b-form-radio
                  v-model="testspace.space_mode"
                  :disabled="true"
                  name="space_mode"
                  value="limited"
                  >Limited</b-form-radio
                >
              </div>

              <div
                v-if="testspace.space_mode == 'limited'"
                class="field-division"
              >
                <span class="field-label">Space question limit</span>
                <b-form-spinbutton
                  id="modeque"
                  :disabled="true"
                  :value="Number(testspace.mode_limit_question)"
                  min="0"
                  max="200"
                  step="1"
                ></b-form-spinbutton>
              </div>

              <div
                v-if="testspace.space_mode == 'limited'"
                class="field-division"
              >
                <span class="field-label">Space time limit (mins)</span>
                <b-form-spinbutton
                  id="modeque"
                  :disabled="true"
                  :value="Number(testspace.mode_limit_time)"
                  min="0"
                  max="200"
                  step="1"
                ></b-form-spinbutton>
              </div>

              <div class="field-division">
                <span class="field-label">Allow takers to View Score</span>
                <b-form-radio
                  v-model="testspace.view_score"
                  :disabled="true"
                  name="viewscore"
                  value="Yes"
                  >Yes</b-form-radio
                >
                <b-form-radio
                  v-model="testspace.view_score"
                  :disabled="true"
                  name="viewscore"
                  value="No"
                  >No</b-form-radio
                >
              </div>

              <div class="field-division">
                <span class="field-label">Allow takers to View Solution</span>
                <b-form-radio
                  v-model="testspace.view_solution"
                  :disabled="true"
                  name="viewsolution"
                  value="Yes"
                  >Yes</b-form-radio
                >
                <b-form-radio
                  v-model="testspace.view_solution"
                  :disabled="true"
                  name="viewsolution"
                  value="No"
                  >No</b-form-radio
                >
              </div>

              <div class="field-division">
                <span class="field-label">Test Start date</span>
                <b-form-input
                  :disabled="true"
                  :value="dateFormatter(`${testspace.test_startdate}`)"
                  placeholder="Topic Reference"
                ></b-form-input>
              </div>

              <div class="field-division">
                <span class="field-label">Test End date</span>
                <b-form-input
                  :disabled="true"
                  :value="dateFormatter(`${testspace.test_enddate}`)"
                  placeholder="Topic Reference"
                ></b-form-input>
              </div>

              <div class="field-division">
                <span class="field-label">Test Mode</span>
                <b-form-select :disabled="true">
                  <b-form-select-option :value="testspace.test_mode">{{
                    testspace.test_mode
                  }}</b-form-select-option>
                </b-form-select>
              </div>

              <div class="field-division">
                <span class="field-label">Test Status</span>
                <b-form-radio
                  v-model="testspace.test_status"
                  :disabled="true"
                  name="status"
                  value="Open"
                  >Open</b-form-radio
                >
                <b-form-radio
                  v-model="testspace.test_status"
                  :disabled="true"
                  name="status"
                  value="Closed"
                  >Closed</b-form-radio
                >
              </div>

              <div class="field-division">
                <span class="field-label">Testspace Link</span>
                <!-- <code>{{ origin }} /testspace/ {{ testspace.trx_code }}</code> -->
                <div>
                  <code class="p-2 m-2 w-100 copyinline" id="copyinline">
                    <p class="copytext" id="copytext">
                      {{ origin }}/testspace/{{ testspace.trx_code }}
                    </p>
                    <b-icon-folder
                      @click="copylink()"
                      class="copyicon"
                      font-scale="2"
                    ></b-icon-folder>
                    <span class="copied" v-if="showcopy">Copied!</span>
                  </code>
                  <!--<b-form-input @input="copynow()" v-model="copytext" class="copier" id="copier"></b-form-input></b-form-input>-->
                </div>
              </div>
            </div>

            <div class="footer-edit text-right mt-3">
              <b-button
                class="v-button p-lg-2"
                :to="{
                  name: 'edittestspaces',
                  hash: '#config',
                  params: { trackid: testspace.track_id }
                }"
                variant="success"
                >Edit <b-icon-pencil-square></b-icon-pencil-square
              ></b-button>
            </div>
          </div>

          <div class="card p-3 m-lg-3 mb-2">
            <div class="header-card">
              <p class="card-title">Testspace Users</p>
            </div>
            <div class="body-card">
              <div class="field-division">
                <span class="field-label">Space Users</span>
                <b-form-tags
                  input-id="tags-separators"
                  :value="JSON.parse(testspace.test_takers)"
                  separator=","
                  :disabled="true"
                  class="tag-input"
                  placeholder="Enter new separated by Comma"
                ></b-form-tags>
                {{ JSON.parse(testspace.test_takers).length }} Users are in this
                Testspace
              </div>

              <div class="field-division">
                <p class="field-label">Testspace Solid Users</p>
                <p>
                  {{ JSON.parse(testspace.takers_taken).length }} User{{
                    JSON.parse(testspace.takers_taken).length > 1 ? "s" : ""
                  }}
                  Have taken this Test at least once
                </p>
              </div>
            </div>

            <div class="footer-edit text-right mt-3">
              <b-button
                class="v-button p-lg-2"
                :to="{
                  name: 'edittestspaces',
                  hash: '#users',
                  params: { trackid: testspace.track_id }
                }"
                variant="success"
                >Edit <b-icon-pencil-square></b-icon-pencil-square
              ></b-button>
            </div>
          </div>

          <div class="card p-3 m-lg-3 mb-2">
            <div class="header-card">
              <p class="card-title">Test Stats/Results</p>
            </div>
            <div class="body-card">
              <div class="field-division">
                <span class="field-label">Test takers</span>
                <mini-pie :chartdata="testspacestats.takerschart"></mini-pie>
              </div>

              <div class="field-division">
                <span class="field-label">Test users Performance</span>
                <mini-pie :chartdata="testspacestats.scorechart"></mini-pie>
              </div>

              <div class="field-division">
                <!-- <span class="field-label">Download results</span> -->
                <div class="text-center">
                  <b-overlay
                    :show="preparing"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="inline-overlay"
                  >
                    <b-button
                      class="mt-lg-3 action-button ml-lg-2"
                      @click="prepareResult"
                      variant="info"
                      ><b-icon-file-earmark-arrow-down></b-icon-file-earmark-arrow-down>
                      Prepare fresh Result
                    </b-button>
                  </b-overlay>
                  <!-- <a
                    :href="downloadlink"
                    download
                    target="_blank"
                    class="text-center"
                  >
                    </a> -->
                  <b-button
                    class="mt-lg-3 action-button ml-lg-2 mt-3"
                    @click="downloadResult"
                    variant="success"
                    ><b-icon-file-earmark-arrow-down></b-icon-file-earmark-arrow-down>
                    Download Result as CSV
                  </b-button>
                </div>
                <div class="text-center" v-if="prepared">
                  <b-button
                    class="mt-lg-3 action-button ml-lg-2 mt-3"
                    @click="viewresult = !viewresult"
                    variant="warning"
                    ><b-icon-eye-fill v-if="!viewresult"></b-icon-eye-fill>
                    <b-icon-eye-slash-fill
                      v-if="viewresult"
                    ></b-icon-eye-slash-fill>
                    View Result
                  </b-button>
                </div>
              </div>
            </div>

            <div class="footer-edit text-right mt-3" v-if="viewresult">
              <div v-if="tabledata.data.length > 0">
                <h2 class="text-center">{{ tabledata.name }}</h2>
                <h4 class="text-center" v-if="tabledata.data.length > 0">
                  This Table has {{ tabledata.data.length }} rows
                </h4>
                <tabler2
                  v-if="tabledata.data.length > 0"
                  class="esq m-0 p-0"
                  :clearance="1"
                  :datas="tabledata.data"
                  :fields="tabledata.fields"
                ></tabler2>
              </div>
              <paginater
                :intervalnum="intervalnum"
                :pages="pages"
                :endss="endss"
                :endnum="endnum"
                :datalength="endss"
                @paginator="newPage"
                @changeInterval="effectInterval"
              ></paginater>
            </div>
          </div>

          <div class="card p-3 m-lg-3 mb-2">
            <div class="header-card">
              <p class="card-title">Testspace Operations</p>
            </div>
            <div class="body-card">
              <div class="field-division">
                <b-modal
                  id="modal-clear-result"
                  centered
                  title="Confirm Clearing Results"
                  ok
                  ok-variant="success"
                  cancel-variant="danger"
                  @ok="clearResults()"
                >
                  <template v-slot:modal-ok> Clear results </template>
                  <p>
                    Are you sure you want to Clear this Space Results? Every
                    Test taken under this Space will be deleted!
                  </p>
                </b-modal>
                <b-link class="Opslink" @click.prevent="confirmClear"
                  >Clear Space Results</b-link
                >
              </div>

              <div class="field-division">
                <b-modal
                  id="modal-truncate-space"
                  centered
                  title="Confirm Truncating Space Users"
                  ok
                  ok-variant="success"
                  cancel-variant="danger"
                  @ok="truncateUsers()"
                >
                  <template v-slot:modal-ok> Truncate Space </template>
                  <p>
                    Are you sure you want to Truncate this Space Users? It will
                    remove every User Email that has been previously added in
                    this space!
                  </p>
                </b-modal>
                <b-link class="Opslink" @click.prevent="confirmTruncate"
                  >Truncate Space Users</b-link
                >
              </div>

              <div class="field-division">
                <b-modal
                  id="modal-delete-space"
                  centered
                  title="Confirm remove"
                  ok
                  ok-variant="success"
                  cancel-variant="danger"
                  @ok="deleteSpace()"
                >
                  <template v-slot:modal-ok> Delete Testsapce</template>
                  <p>
                    Are you sure you want to delete this Testspace? Every Data
                    associated with this Space will be deleted, including users
                    result!
                  </p>
                </b-modal>
                <b-link class="Opslink" @click.prevent="confirmDelete"
                  >Delete Testspace</b-link
                >
              </div>
            </div>

            <div class="footer-edit text-right mt-3">
              <b-button
                class="v-button p-lg-2"
                :to="{
                  name: 'edittestspaces',
                  hash: '#users',
                  params: { trackid: testspace.track_id }
                }"
                variant="success"
                >Edit <b-icon-pencil-square></b-icon-pencil-square
              ></b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "@/store";
import miniPie from "@/components/miniPie";
import Tabler2 from "@/components/admin/Tabler2";
import Paginater from "@/components/Paginater";

export default {
  components: {
    miniPie,
    Tabler2,
    Paginater
  },
  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      //   testspace: {},
      prepared: false,
      preparing: false,
      downloadlink: "",
      tabledata: {
        data: []
      },
      viewresult: false,
      levels: [10, 25, 50, 100, 250, 500],
      spacetrackid: "",
      copytext: "",
      showcopy: false
    };
  },
  created() {
    let spacetrackid = this.$route.params.trackid;
    this.spacetrackid = spacetrackid;
    // console.log(currenttestspace)
    this.downloadlink = this.testspace.test_resultslink;
    setInterval(this.refetchStats, 180000);
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/fetchTestspaces");
    store.dispatch("admin/fetchCategories");
    store.dispatch("admin/fetchInstitutions");

    let spaceid = to.params.trackid;
    store.dispatch("admin/fetchSpacestats", { spaceid: spaceid });
    store.dispatch("admin/fetchSpaceresults", { spaceid });
    // store.dispatch("admin/fetchQuestions");

    next();
  },
  methods: {
    ...mapActions("admin", [
      "fetchSpacestats",
      "fetchTestspaces",
      "fetchOrganization",
      "fetchSpaceresults",
      "prepareSpaceresults",
      "DownloadSpaceresults",
      "clearResultsops",
      "truncateUsersops",
      "deleteSpaceops"
    ]),
    newPage(page) {
      // alert(page)
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },
    refetchStats() {
      let spaceid = {
        spaceid: this.$route.params.trackid
      };
      // console.log(spaceid)
      this.fetchSpacestats(spaceid);
      this.fetchSpaceresults(spaceid);
      this.fetchTestspaces();
      this.fetchOrganization();
    },
    refetchSpace() {
      let spaceid = {
        spaceid: this.$route.params.trackid
      };
      // console.log(spaceid)
      this.fetchSpacestats(spaceid);
      this.fetchSpaceresults(spaceid);
      this.fetchTestspaces();
      this.fetchOrganization();
    },

    dateFormatter(rawdate) {
      let monthArray = [
        "Jan",
        "Feb",
        "Mar",
        "April",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec"
      ];
      let daysArray = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      let sdate = new Date(rawdate);
      let sdatestring =
        daysArray[sdate.getUTCDay()] +
        ", " +
        monthArray[sdate.getMonth()] +
        " " +
        sdate.getDate() +
        ", " +
        sdate.getFullYear();

      return sdatestring;
    },
    timeformatter(rawdatetime) {
      // let monthArray = ["Jan", "Feb", "Mar", "April", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
      let sdate = new Date(rawdatetime);
      // let sdatestring =  monthArray[sdate.getMonth()] + ' ' + sdate.getDate() + ', ' + sdate.getFullYear();
      // this.scheduledate = sdatestring
      let stimestring =
        (sdate.getHours() < 12 ? sdate.getHours() : sdate.getHours() - 12) +
        ":" +
        (sdate.getMinutes() < 10
          ? `0${sdate.getMinutes()}`
          : sdate.getMinutes()) +
        (sdate.getHours() < 12 ? "am" : "pm");
      // this.scheduletime = stimestring;

      return stimestring;
    },
    makeString(rawarray) {
      let arraystring = rawarray.toString();

      return arraystring;
    },
    prepareResult() {
      let spaceid = this.$route.params.trackid;

      let prepareObj = {
        spaceid,
        origin: this.origin,
        environment: this.environ
      };

      this.preparing = true;
      this.prepared = false;

      return this.prepareSpaceresults(prepareObj).then(response => {
        this.prepared = true;
        this.preparing = false;
        this.tabledata = response;
      });
    },
    downloadResult() {
      let spaceid = this.$route.params.trackid;

      let prepareObj = {
        spaceid,
        origin: this.origin,
        environment: this.environ
      };

      this.preparing = true;
      this.prepared = false;

      return this.DownloadSpaceresults(prepareObj).then(response => {
        this.prepared = true;
        this.preparing = false;
        this.downloadlink = response[0];
        // this.tabledata = response[1];

        const blob = new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = this.testspace.test_title + ".csv"; // Specify the filename
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    confirmClear() {
      this.$bvModal.show("modal-clear-result");
    },
    confirmTruncate() {
      this.$bvModal.show("modal-truncate-space");
    },
    confirmDelete() {
      this.$bvModal.show("modal-delete-space");
    },
    deleteSpace() {
      return this.deleteSpaceops(this.spacetrackid).then(() => {
        this.refetchSpace();
        this.$router.push({
          name: "listtestspaces"
        });
      });
    },
    truncateUsers() {
      return this.truncateUsersops(this.spacetrackid).then(() => {
        this.refetchSpace();
      });
    },
    clearResults() {
      return this.clearResultsops(this.spacetrackid).then(() => {
        this.refetchSpace();
      });
    },
    copylink() {
      // var cop = document.getElementById("copier")
      // cop.select()
      // cop.setSelectionRange(0, 99999);
      // document.execCommand("copy")
      navigator.clipboard.writeText(
        `${this.origin}/testspace/${this.testspace.trx_code}`
      );
      this.showcopy = true;
    }
  },

  computed: {
    ...mapState({
      testspacearray: state => state.admin.listtestspaces,
      testspacestats: state => state.admin.testspacestats,
      origin: state => state.loginmaster.site_origin,
      environ: state => state.loginmaster.environ
    }),

    usedatas() {
      return this.tabledata.data.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.tabledata.data.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(this.tabledata.data.length / this.intervalnum);
      return ranger;
    },
    retrieving() {
      //let trid = this.$route.params.trackid;

      let curres = this.testspacearray.length;
      //this.result = curres;

      if (curres <= 0) {
        return true;
      } else {
        return false;
      }
    },
    testspace() {
      let currenttestspace = this.testspacearray.filter(
        x => x.track_id == this.spacetrackid
      );
      let testspace = currenttestspace[0];
      return testspace;
    }
  }
};
</script>

<style scoped>
.card {
  /* min-height: 70vh; */
  background-color: rgb(242, 242, 242);
  border-radius: 20px 20px;
}
.card-title {
  font-size: 1.5rem;
  font-weight: bold;
}
.field-division {
  margin-top: 7px;
}
.tag-input {
  overflow: auto;
  scrollbar-width: thin;
  max-height: 400px;
}
.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  /* height: 3rem; */
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.footer-edit {
  width: 100%;
}
.field-label {
  font-size: 1.2rem;
  font-weight: bold;
}

.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}

.page-buttons {
  width: 35px;
  height: 35px;
}
.active-page-btn {
  background-color: #00377b;
  color: white;
}
.button-pager-group {
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: thin;
}
.Opslink {
  color: red;
  font-weight: bold;
  font-size: 1.5rem;
  text-decoration: none;
}
.Opslink:hover {
  text-decoration: none;
}
.copyinline {
  background-color: #000000;
  color: white;
  display: inline-flex;
  overflow: auto;
  scrollbar-width: thin;
  border-radius: 10px 10px;
}

.copyicon {
  width: 10%;
  cursor: pointer;
  left: -100px;
}

.copytext {
  width: 90%;
  overflow: auto;
  scrollbar-width: thin;
}

.copier {
  position: absolute;
  left: -9999px;
}
.copied {
  position: relative;
  left: -10px;
  font-size: 0.7rem;
}
.lba {
  display: inline-block;
  background-color: #00984a;
  color: white;
  width: 200px;
  font-size: 1.2rem;
  font-weight: bold;
  text-decoration: none;
  border-radius: 10px 10px;
}

.inline-overlay {
  display: inline;
}

@media (max-width: 999px) {
  .v-button {
    width: inherit;
    /* height: 2.5rem; */
    font-size: 0.8rem;
  }
  .s-header {
    font-size: 16px;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
}
</style>
